export { GoogleRatingsDisplay } from './google-ratings-display';
